<template>
    <div>
        <ClienteHeader></ClienteHeader>
        <router-view class="container">
        </router-view>
    </div>
</template>

<script>
import ClienteHeader from "./_cabecalho";
import {clientKey} from '../global/utils'
    export default {
    components: { ClienteHeader },

    data() {
        return {
            validationToken: true
        }
    },

    methods: {
 async validateToken(){
            this.validationToken = true
            const userData = localStorage.getItem(clientKey)
            if(!userData)
            {
                this.$store.commit('setClient',null)
                this.validationToken = false
                this.$router.push({name: "auth"})
                return
            }
            const res = await this.$http.post('clientes/validate',userData)
            if(res.data){
                this.$store.commit('setClient', localStorage.getItem(clientKey))
                localStorage.setItem(clientKey,userData)
                this.idUsuario = userData.userId
            }else{
              localStorage.removeItem(clientKey)
              this.$router.push({name: "auth"})
            }
            this.validationToken = false
          }, 
    convertToken(token) {
          var base64Url = token.split('.')[1];
          var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
          }).join(''));
      
          return JSON.parse(jsonPayload);
      }
    },
  created() {
    this.validateToken()
  },  
}


</script>

<style lang="scss" scoped>

</style>